(function () {
    'use strict';

    angular.module("imApp").factory("interBranchLevelService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 792,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 793,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
